export const accessLevels = {
  none: 0,
  headwaiter: 1,
  supervisor: 2,
  manager: 3,
  boss: 4,
  admin: 5,
}

// The minimum access level for each user actions
export const userActions = {
  // Super-respo
  readShiftDetails: 2,
  readShiftTimesheets: 2,
  readShiftComments: 2,
  readShiftBalances: 2,

  // Gérant
  editShiftTimesheets: 3,
  editShiftComments: 3,
  editShiftBalances: 3,
  editInvoiceIssued: 3,
  editInvoicePaid: 3,
  editExpenseInvoices: 3,
  deleteOtherUsersMessages: 3,
  accessShiftControls: 3,
  openPayroll: 3,
  openTeam: 3,
  openRemoval: 3,
  readWriteNotes: 3,
  accessV2: 3,

  // Boss
  openOptions: 4,
  openAccounting: 4,
  openResults: 4,

  // Moi
  incorporate: 5,
  openAdmin: 5,
  mock: 5,
}

// Default role permissions for the flexible role-based system
export const defaultRolePermissions = {
  headwaiter: {
    deleteOtherUsersMessages: false,
    readWriteNotes: false,
    editOwnShiftDetails: true,
    readShiftTimesheets: false,
    editShiftTimesheets: false,
    readShiftComments: false,
    editShiftComments: false,
    readShiftBalances: false,
    editShiftBalances: false,
    accessShiftControls: false,
    editInvoiceIssued: false,
    editInvoicePaid: false,
    editExpenseInvoices: false,
    openPayroll: false,
    openAccounting: false,
    openResults: false,
    openTeam: false,
    openOptions: false,
    openRemoval: false,
  },
  supervisor: {
    deleteOtherUsersMessages: false,
    readWriteNotes: true,
    editOwnShiftDetails: true,
    readShiftTimesheets: true,
    editShiftTimesheets: false,
    readShiftComments: true,
    editShiftComments: false,
    readShiftBalances: true,
    editShiftBalances: false,
    accessShiftControls: false,
    editInvoiceIssued: false,
    editInvoicePaid: false,
    editExpenseInvoices: false,
    openPayroll: false,
    openAccounting: false,
    openResults: false,
    openTeam: false,
    openOptions: false,
    openRemoval: false,
  },
  manager: {
    deleteOtherUsersMessages: true,
    readWriteNotes: true,
    editOwnShiftDetails: true,
    readShiftTimesheets: true,
    editShiftTimesheets: true,
    readShiftComments: true,
    editShiftComments: true,
    readShiftBalances: true,
    editShiftBalances: true,
    accessShiftControls: true,
    editInvoiceIssued: true,
    editInvoicePaid: true,
    editExpenseInvoices: true,
    openPayroll: true,
    openAccounting: false,
    openResults: false,
    openTeam: true,
    openOptions: false,
    openRemoval: true,
  },
  boss: {
    readWriteNotes: true,
    deleteOtherUsersMessages: true,
    editOwnShiftDetails: true,
    readShiftTimesheets: true,
    editShiftTimesheets: true,
    readShiftComments: true,
    editShiftComments: true,
    readShiftBalances: true,
    editShiftBalances: true,
    accessShiftControls: true,
    editInvoiceIssued: true,
    editInvoicePaid: true,
    editExpenseInvoices: true,
    openPayroll: true,
    openAccounting: true,
    openResults: true,
    openTeam: true,
    openOptions: true,
    openRemoval: true,
  },
}
